import { render, staticRenderFns } from "./StandardOrder.vue?vue&type=template&id=8a62d05a"
import script from "./StandardOrder.vue?vue&type=script&lang=js"
export * from "./StandardOrder.vue?vue&type=script&lang=js"
import style0 from "./StandardOrder.vue?vue&type=style&index=0&id=8a62d05a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports